import { SuggestionResult } from 'core/type/SuggestionResult.types';

export interface NearBySuggestion {
    suggestion: SuggestionResult;
    matchType: NearBySuggestionMatchType;
}

export enum NearBySuggestionMatchType {
    City = 1, // represent a match city from nearby search
    TopDestination = 2, // represent fallback, when nearby city not found and top destination found
}
